"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleApiProvider = exports.useGoogleApi = void 0;
const api_1 = require("@react-google-maps/api");
const react_1 = __importStar(require("react"));
const GoogleApiContext = (0, react_1.createContext)(null);
const useGoogleApi = () => {
    const context = (0, react_1.useContext)(GoogleApiContext);
    if (!context) {
        throw new Error("useGoogleApi must be used within a GoogleApiProvider");
    }
    return context;
};
exports.useGoogleApi = useGoogleApi;
const LIBRARIES = ["maps", "places", "geometry"];
const GoogleApiProvider = ({ children, googleApiKey }) => {
    const googleMapsApiKey = process.env.NEXT_PUBLIC_DAYTRIP_GOOGLE_MAPS_API_KEY || googleApiKey || "";
    const { isLoaded, loadError } = (0, api_1.useJsApiLoader)({
        id: "google-map-script",
        googleMapsApiKey: googleMapsApiKey,
        libraries: LIBRARIES,
    });
    return react_1.default.createElement(GoogleApiContext.Provider, { value: { isLoaded, loadError } }, children);
};
exports.GoogleApiProvider = GoogleApiProvider;
//# sourceMappingURL=google-maps-api-provider.js.map